const selectInputBox = () => ({
    activeDescendant: null,
    optionCount: null,
    open: false,
    activeIndex: null,
    selectedIndex: 0,
    items: [],
    selectedValue: '',

    init: function () {
        this.items = Array.from(this.$refs.listbox.querySelectorAll('li'))

        this.optionCount = this.$refs.listbox.children.length
        this.$watch('activeIndex', (e) => {
            this.open && (null !== this.activeIndex ? (this.activeDescendant = this.$refs.listbox.children[this.activeIndex].id) : (this.activeDescendant = ''))
        })

        this.selectedValue = this.$refs.select.value
        setInterval(() => {
            if (this.$refs && this.$refs.select && this.$refs.select.value) {
                const currentValue = this.$refs.select.value
                if (currentValue !== this.selectedValue) {
                    this.selectedValue = currentValue
                }

                const item = this.$refs.listbox.querySelector(`[data-value="${ this.selectedValue }"]`)
                if (item && item.dataset.index !== this.selectedIndex) {
                    this.activeIndex = item.dataset.index
                    this.selectedIndex = item.dataset.index
                } else if (!item) {
                    this.activeIndex = null
                    this.selectedIndex = 0
                }
            }
        }, 500)
    },

    get active() {
        return this.items[this.activeIndex]
    },

    get selected() {
        return this.items[this.selectedIndex]
    },

    choose(e) {
        this.selectedIndex = e
        this.open = false
        this.$refs.select.selectedIndex = e

        // Get the selected value from the option element
        const selectedValue = this.$refs.select.options[e].value || this.$refs.select.options[e].text

        // Update the select element's value directly without triggering a Livewire update
        this.$refs.select.value = selectedValue

        // Dispatch a change event to ensure the value is recognized by the form
        this.$refs.select.dispatchEvent(new Event('change', { bubbles: true }))
    },

    onButtonClick() {
        if (!this.open) {
            // Set activeIndex to the currently selected index
            this.activeIndex = this.selectedIndex

            // Toggle the open state to true
            this.open = true

            // Use $nextTick to ensure updates are processed before manipulating the DOM
            this.$nextTick(() => {
                // Focus on the listbox element
                this.$refs.listbox.focus()

                // Scroll the currently active item into view
                this.$refs.listbox.children[this.activeIndex].scrollIntoView({ block: 'nearest' })
            })
        }
    },

    onOptionSelect() {
        null !== this.activeIndex && (this.selectedIndex = this.activeIndex), (this.open = !1), this.$refs.button.focus()
    },

    onEscape() {
        (this.open = !1), this.$refs.button.focus()
    },

    onArrowUp() {
        (this.activeIndex = this.activeIndex - 1 < 0 ? this.optionCount - 1 : this.activeIndex - 1), this.$refs.listbox.children[this.activeIndex].scrollIntoView({ block: 'nearest' })
    },

    onArrowDown() {
        (this.activeIndex = this.activeIndex + 1 > this.optionCount - 1 ? 0 : this.activeIndex + 1), this.$refs.listbox.children[this.activeIndex].scrollIntoView({ block: 'nearest' })
    },

    setActiveIndex(index) {
        if (this.activeIndex !== index) {
            this.activeIndex = index
        }
    }
})

const toggleButton = () => ({
    selected: null,
    id: null,
    init() {
        // Work out if there was a default value
        const selectedEl = this.$el.querySelectorAll('input[checked]')
        if (selectedEl.length > 0) {
            this.selected = selectedEl[0].value
        }

        this.id = this.$el.dataset.id
    },

    handleClickEvent(event) {
        this.$dispatch('toggle-button', {
            id: this.id,
            value: event.target.nextElementSibling.value
        })
    }
})

export { selectInputBox, toggleButton }
